import { render, staticRenderFns } from "./part-price-info.vue?vue&type=template&id=61e53222&scoped=true"
import script from "./part-price-info.vue?vue&type=script&lang=js"
export * from "./part-price-info.vue?vue&type=script&lang=js"
import style0 from "./part-price-info.vue?vue&type=style&index=0&id=61e53222&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e53222",
  null
  
)

export default component.exports